import RequestHandler from "./request-handler";
class HotWaterTableSummarizedService {
    constructor() {
        this.path = "HotWaterTableSummarized";
        if (HotWaterTableSummarizedService.instance) {
            return HotWaterTableSummarizedService.instance;
        }
        HotWaterTableSummarizedService.instance = this;
        return this;
    }
    async get(id) {
        return await RequestHandler.get(this.path, id);
    }
    async getColumns() {
        return await RequestHandler.get(this.path + '/columns');
    }
}
const instance = new HotWaterTableSummarizedService();
export default instance;